module.exports = __webpack_public_path__ + "img/setup-test-step-3-desktop.8b8ce34d.png";